import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createChoices } from './plugins/choices'
import { config } from './plugins/config'
import App from './App.vue'
import router from './router'
import axiosBackendInstance from './plugins/axiosB'
import axiosWebInstance from './plugins/axiosW'
import axiosInstance from './plugins/axios'
import sweetalert from './plugins/sweetalert'
import utils from './plugins/utils'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(utils)

app.config.globalProperties.$captchaImageUrl = config.apiUrl + '/Captcha/Generate?timestamp='
app.config.globalProperties.$axiosB = axiosBackendInstance
app.config.globalProperties.$axiosW = axiosWebInstance
app.config.globalProperties.$axios = axiosInstance
app.config.globalProperties.$swal = sweetalert
app.config.globalProperties.$choices = createChoices

app.config.globalProperties.$scrollTo = function (id) {
  const element = document.getElementById(id)
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}

// 語音驗證碼
app.config.globalProperties.$captchaAudioUrl = config.apiUrl + '/Captcha/Audio?timestamp='

app.mount('#app')
